if (!customElements.get('lookbook-card')) {
  customElements.define(
    'lookbook-card',
    class LookbookCard extends ModalComponent {
      constructor() {
        super();

        this.card = this.closest('.lbcard');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = () => {
          this.removeAttribute('open');
          document.body.classList.remove(this.classes.show);
        };
      }

      get isLockingNeeded() {
        return FoxTheme.config.mqlMobile;
      }
    
      get requiresBodyAppended() {
        return FoxTheme.config.mqlMobile;
      }

      prepareToShow() {
        super.prepareToShow();

        this.card.classList.add('is-open');
      }

      handleAfterHide() {
        super.handleAfterHide();

        this.card.classList.remove('is-open');
      }
    }
  );
}

if (!customElements.get('lookbook-card-wrapper')) {
  customElements.define(
    'lookbook-card-wrapper',
    class LookbookCardWrapper extends HTMLElement {
      constructor() {
        super();
      }

      get video() {
        return this.querySelector('video-element');
      }

      connectedCallback() {
        if (!this.video) return;

        this.addEventListener('mouseleave', this.handleMouseInteraction.bind(this, 'leave'));
        this.addEventListener('mouseenter', this.handleMouseInteraction.bind(this, 'enter'));
      }

      disconnectedCallback() {
        this.removeEventListener('mouseleave');
        this.removeEventListener('mouseenter');
      }

      handleMouseInteraction(type, event) {
        if (type === 'enter') {
          this.classList.add('is-hovering');
          this.video.play();
        } else {
          this.classList.remove('is-hovering');
          this.video.pause();
        }
      }
    }
  );
}

/* =========================
  Florona – Add Full Composition
  - Add all items to cart
  - Refresh Hyper cart drawer UI immediately
  - Open CartDrawer via theme trigger
========================= */
(() => {
  const safeJsonParse = (str, fallback = []) => {
    try {
      const v = JSON.parse(str);
      return Array.isArray(v) ? v : fallback;
    } catch (e) {
      return fallback;
    }
  };

  const addAllToCart = async (items) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  };

  const fetchCart = async () => {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  };

  const refreshCartUI = async () => {
    const cart = await fetchCart();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
    return cart;
  };

  const openCartDrawer = () => {
    document.querySelector('[aria-controls="CartDrawer"]')?.click();
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[data-lb-add-all]');
    if (!btn) return;

    e.preventDefault();

    // soft lock chống spam request (KHÔNG làm xám nút)
    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';

    const items = safeJsonParse(btn.getAttribute('data-items') || '[]', []);
    if (!items.length) {
      btn.dataset.loading = '0';
      return;
    }

    try {
      await addAllToCart(items);
      await refreshCartUI();   // quan trọng: để cart drawer update ngay, không cần reload
      openCartDrawer();
    } catch (err) {
      console.error('[Add Full Composition]', err);
    } finally {
      btn.dataset.loading = '0';
    }
  });
})();